import React from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const ScrollToBottomButton = ({ show, onClick, isMobile, style }) => {
  // Show on both mobile and desktop when needed
  if (!show) return null;

  return (
    <AnimatePresence>
      <motion.button
        onClick={onClick}
        className="bg-emerald-600/90 hover:bg-emerald-600 text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg"
        style={style || {
          position: 'absolute',
          bottom: '1rem',
          right: '1rem'
        }}
        initial={{ opacity: 0, scale: 0.8, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.8, y: 20 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.2 }}
        aria-label="Scroll to bottom"
      >
        <ChevronDown className="w-6 h-6" />
      </motion.button>
    </AnimatePresence>
  );
};

export default ScrollToBottomButton;